import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import ProfilePicture from '../../../Experts/ProfilePicture';
import ProfileModal from '../../../Experts/ProfileModal';
import CopyLinkButton from '../../../CopyLinkButton';
import CurrentEmploymentInfo from '../../../Experts/CurrentEmploymentInfo';
import Security from '../../../../utils/Security';

const ExpertInformation = ({ job }) => {
  const isSuperUser = Security.isSuperUser();

  return (
    <ProfileModal expertId={job.expert.id}>
      <div className="span-link">
        <ProfilePicture expert={job.expert} />
        <Card.Header>
          {job.expert.fullName}
          {(job.project.team.name === 'Decibio' || isSuperUser) && (
          <CopyLinkButton
            className="link-btn"
            copyText={job.user.email}
            copyPopMessage="Copied email address!"
            icon="mail"
          />
          )}
        </Card.Header>
        <CurrentEmploymentInfo>
          <Card.Meta>
            {`${job.expert.title} ${job.expert.organization.name}`}
          </Card.Meta>
          <Card.Meta>
            {job.expert.country}
          </Card.Meta>
        </CurrentEmploymentInfo>
        <Card.Meta>
          <Icon name="university" />
          {`${job.expert.credits} credits`}
        </Card.Meta>
      </div>
    </ProfileModal>
  );
};

export default ExpertInformation;
